import { Schedule } from '@cotera/api';

export enum CronExpression {
  EVERY_SECOND = '* * * * * *',
  EVERY_5_SECONDS = '*/5 * * * * *',
  EVERY_10_SECONDS = '*/10 * * * * *',
  EVERY_30_SECONDS = '*/30 * * * * *',
  EVERY_MINUTE = '*/1 * * * *',
  EVERY_5_MINUTES = '0 */5 * * * *',
  EVERY_10_MINUTES = '0 */10 * * * *',
  EVERY_15_MINUTES = '0 */15 * * * *',
  EVERY_30_MINUTES = '0 */30 * * * *',
  EVERY_HOUR = '0 0-23/1 * * *',
  EVERY_2_HOURS = '0 0-23/2 * * *',
  EVERY_3_HOURS = '0 0-23/3 * * *',
  EVERY_4_HOURS = '0 0-23/4 * * *',
  EVERY_5_HOURS = '0 0-23/5 * * *',
  EVERY_6_HOURS = '0 0-23/6 * * *',
  EVERY_7_HOURS = '0 0-23/7 * * *',
  EVERY_8_HOURS = '0 0-23/8 * * *',
  EVERY_9_HOURS = '0 0-23/9 * * *',
  EVERY_10_HOURS = '0 0-23/10 * * *',
  EVERY_11_HOURS = '0 0-23/11 * * *',
  EVERY_12_HOURS = '0 0-23/12 * * *',
  EVERY_DAY_AT_1AM = '0 01 * * *',
  EVERY_DAY_AT_2AM = '0 02 * * *',
  EVERY_DAY_AT_3AM = '0 03 * * *',
  EVERY_DAY_AT_4AM = '0 04 * * *',
  EVERY_DAY_AT_5AM = '0 05 * * *',
  EVERY_DAY_AT_6AM = '0 06 * * *',
  EVERY_DAY_AT_7AM = '0 07 * * *',
  EVERY_DAY_AT_8AM = '0 08 * * *',
  EVERY_DAY_AT_9AM = '0 09 * * *',
  EVERY_DAY_AT_10AM = '0 10 * * *',
  EVERY_DAY_AT_11AM = '0 11 * * *',
  EVERY_DAY_AT_NOON = '0 12 * * *',
  EVERY_DAY_AT_1PM = '0 13 * * *',
  EVERY_DAY_AT_2PM = '0 14 * * *',
  EVERY_DAY_AT_3PM = '0 15 * * *',
  EVERY_DAY_AT_4PM = '0 16 * * *',
  EVERY_DAY_AT_5PM = '0 17 * * *',
  EVERY_DAY_AT_6PM = '0 18 * * *',
  EVERY_DAY_AT_7PM = '0 19 * * *',
  EVERY_DAY_AT_8PM = '0 20 * * *',
  EVERY_DAY_AT_9PM = '0 21 * * *',
  EVERY_DAY_AT_10PM = '0 22 * * *',
  EVERY_DAY_AT_11PM = '0 23 * * *',
  EVERY_DAY_AT_MIDNIGHT = '0 0 * * *',
  EVERY_WEEK = '0 0 * * 0',
  EVERY_WEEKDAY = '0 0 * * 1-5',
  EVERY_WEEKEND = '0 0 * * 6,0',
  EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT = '0 0 1 * *',
  EVERY_1ST_DAY_OF_MONTH_AT_NOON = '0 12 1 * *',
  EVERY_2ND_HOUR = '0 */2 * * *',
  EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM = '0 1-23/2 * * *',
  EVERY_2ND_MONTH = '0 0 1 */2 *',
  EVERY_QUARTER = '0 0 1 */3 *',
  EVERY_6_MONTHS = '0 0 1 */6 *',
  EVERY_YEAR = '0 0 1 0 *',
  EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM = '0 */30 9-17 * * *',
  EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM = '0 */30 9-18 * * *',
  EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM = '0 */30 10-19 * * *',
  MONDAY_TO_FRIDAY_AT_1AM = '0 0 01 * * 1-5',
  MONDAY_TO_FRIDAY_AT_2AM = '0 0 02 * * 1-5',
  MONDAY_TO_FRIDAY_AT_3AM = '0 0 03 * * 1-5',
  MONDAY_TO_FRIDAY_AT_4AM = '0 0 04 * * 1-5',
  MONDAY_TO_FRIDAY_AT_5AM = '0 0 05 * * 1-5',
  MONDAY_TO_FRIDAY_AT_6AM = '0 0 06 * * 1-5',
  MONDAY_TO_FRIDAY_AT_7AM = '0 0 07 * * 1-5',
  MONDAY_TO_FRIDAY_AT_8AM = '0 0 08 * * 1-5',
  MONDAY_TO_FRIDAY_AT_9AM = '0 0 09 * * 1-5',
  MONDAY_TO_FRIDAY_AT_09_30AM = '0 30 09 * * 1-5',
  MONDAY_TO_FRIDAY_AT_10AM = '0 0 10 * * 1-5',
  MONDAY_TO_FRIDAY_AT_11AM = '0 0 11 * * 1-5',
  MONDAY_TO_FRIDAY_AT_11_30AM = '0 30 11 * * 1-5',
  MONDAY_TO_FRIDAY_AT_12PM = '0 0 12 * * 1-5',
  MONDAY_TO_FRIDAY_AT_1PM = '0 0 13 * * 1-5',
  MONDAY_TO_FRIDAY_AT_2PM = '0 0 14 * * 1-5',
  MONDAY_TO_FRIDAY_AT_3PM = '0 0 15 * * 1-5',
  MONDAY_TO_FRIDAY_AT_4PM = '0 0 16 * * 1-5',
  MONDAY_TO_FRIDAY_AT_5PM = '0 0 17 * * 1-5',
  MONDAY_TO_FRIDAY_AT_6PM = '0 0 18 * * 1-5',
  MONDAY_TO_FRIDAY_AT_7PM = '0 0 19 * * 1-5',
  MONDAY_TO_FRIDAY_AT_8PM = '0 0 20 * * 1-5',
  MONDAY_TO_FRIDAY_AT_9PM = '0 0 21 * * 1-5',
  MONDAY_TO_FRIDAY_AT_10PM = '0 0 22 * * 1-5',
  MONDAY_TO_FRIDAY_AT_11PM = '0 0 23 * * 1-5',
}

/**
 * Simple string hash function that works in both browser and Node.js
 */
const simpleHash = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
};

/**
 * Overnight window (UTC) that daily workloads are distributed across, so they
 * run off-peak instead of competing with business-hours warehouse traffic.
 *
 * 05:00-10:59 UTC spans the overnight hours across US timezones year-round:
 * - Eastern: 12 AM - 5 AM EST (winter) / 1 AM - 6 AM EDT (summer)
 * - Pacific: 9 PM - 2 AM PST (winter) / 10 PM - 3 AM PDT (summer)
 */
const OVERNIGHT_WINDOW_START_HOUR_UTC = 5;
const OVERNIGHT_WINDOW_HOURS = 6; // orgs spread across hours 5-10 UTC

/**
 * Generates a deterministic cron schedule using a two-tier approach:
 * - Tier 1: Each customer (orgId) is bucketed into one overnight UTC hour
 * - Tier 2: Each column gets a deterministic minute within that customer's hour
 *
 * The bucketing is a stable hash of the orgId, so a customer's daily workloads
 * always land in the same hour, but customers are spread evenly across the
 * overnight window rather than all firing at once.
 */
export const getDailyScheduleTime = (
  orgId: string,
  entityName: string,
  streamId: string
): { hour: number; minute: number } => {
  // Tier 1: Customer gets bucketed into one of the overnight UTC hours
  const orgHour =
    (simpleHash(orgId) % OVERNIGHT_WINDOW_HOURS) +
    OVERNIGHT_WINDOW_START_HOUR_UTC;

  // Tier 2: Column gets a deterministic minute within that customer's hour
  const columnIdentifier = `${orgId}-${entityName}-${streamId}`;
  const minute = simpleHash(columnIdentifier) % 60; // 0-59

  return { hour: orgHour, minute };
};

/**
 * Legacy function for backward compatibility - now uses two-tier system
 * @deprecated Use getDailyScheduleTime instead for more control
 */
export const getDailyScheduleHour = (identifier: string): number => {
  // For backward compatibility, extract rough orgId from identifier
  const parts = identifier.split('-');
  const orgId = parts.length > 0 && parts[0] ? parts[0] : identifier;

  return (
    (simpleHash(orgId) % OVERNIGHT_WINDOW_HOURS) +
    OVERNIGHT_WINDOW_START_HOUR_UTC
  );
};

export const cadenceToCronSchedule = (
  cadence: Schedule,
  context?: { orgId: string; entityName: string; streamId: string }
): string | null => {
  switch (cadence) {
    case 'hourly':
      return CronExpression.EVERY_HOUR;
    case 'daily':
      if (context) {
        // Two-tier scheduling: customer gets hour, column gets minute within that hour
        const { hour, minute } = getDailyScheduleTime(
          context.orgId,
          context.entityName,
          context.streamId
        );
        return `${minute} ${hour} * * *`; // Run at specific minute within customer's hour
      }
      // Fallback to midnight if no context provided (backward compatibility)
      return CronExpression.EVERY_DAY_AT_MIDNIGHT;
    case 'never':
      return null;
    default:
      return (
        CronExpression[cadence.cron as keyof typeof CronExpression] ??
        cadence.cron
      );
  }
};
